import { render, staticRenderFns } from "./advbottom.vue?vue&type=template&id=8393217e&scoped=true&"
import script from "./advbottom.vue?vue&type=script&lang=js&"
export * from "./advbottom.vue?vue&type=script&lang=js&"
import style0 from "./advbottom.vue?vue&type=style&index=0&id=8393217e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8393217e",
  null
  
)

export default component.exports